class RevoneHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-revone-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-revone-dot]'));
    this.index = 0;
    this.timer = null;
    const autoplay = this.dataset.autoplay === 'true';
    const speed = Number(this.dataset.speed) || 6000;

    if (this.slides.length < 2) return;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });

    if (autoplay) {
      this.timer = setInterval(() => this.goTo((this.index + 1) % this.slides.length), speed);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => {
        this.timer = setInterval(() => this.goTo((this.index + 1) % this.slides.length), speed);
      });
    }

    const scrollBtn = this.querySelector('[data-revone-scroll]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', () => {
        const section = this.closest('.revone-hero-section') || this.closest('.shopify-section');
        const next = section?.nextElementSibling;
        if (next) {
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      });
    }
  }

  goTo(index) {
    this.slides[this.index]?.setAttribute('aria-hidden', 'true');
    this.dots[this.index]?.setAttribute('aria-current', 'false');
    this.index = index;
    this.slides[this.index]?.setAttribute('aria-hidden', 'false');
    this.dots[this.index]?.setAttribute('aria-current', 'true');
  }
}

if (!customElements.get('revone-hero')) {
  customElements.define('revone-hero', RevoneHero);
}
